import {ConfigProvider} from "antd";
import {theme} from "~/styles/theme";
import "./App.css";
import {AuthProvider} from "./context/AuthContext";
import AppRoutes from "./routes/routes";

function App() {
  return (
    <ConfigProvider theme={theme}>
      <AuthProvider>
        <div className="App">
          <AppRoutes />
        </div>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
